<script setup>
const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
});
</script>
<template>
    <div class="max-w-4xl mx-auto my-6 overflow-hidden rounded-custom shadow-custom">
        <iframe
            class="w-full aspect-video"
            :src="'https://www.youtube.com/embed/' + content.youtubeVideoId"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        ></iframe>
    </div>
</template>
